/* eslint-disable no-negated-condition */
/* eslint-env browser */
/* global $, jQuery, signaturePad, SignaturePad, localforage */
/* eslint camelcase: 0, "require-jsdoc": 0, no-unused-vars: 0, max-len:0, no-alert:0, block-scoped-var:0, radix:0, linebreak-style: 0, indent: 0, space-before-function-paren: 0, quotes: 0, eqeqeq: 0, no-multiple-empty-lines: 0, no-else-return: 0, padded-blocks: 0, no-loop-func: 0, spaced-comment: 0, no-redeclare:0, quote-props: 0, max-nested-callbacks: 0  */

(function () {
  'use strict';

  // Check to make sure service workers are supported in the current browser,
  // and that the current page is accessed from a secure origin. Using a
  // service worker from an insecure origin will trigger JS console errors. See
  // http://www.chromium.org/Home/chromium-security/prefer-secure-origins-for-powerful-new-features
  var isLocalhost = Boolean(window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
  );

  if ('serviceWorker' in navigator &&
    (window.location.protocol === 'https:' || isLocalhost)) {
    navigator.serviceWorker.register('service-worker.js')
      .then(function (registration) {
        // updatefound is fired if service-worker.js changes.
        registration.onupdatefound = function () {
          // updatefound is also fired the very first time the SW is installed,
          // and there's no need to prompt for a reload at that point.
          // So check here to see if the page is already controlled,
          // i.e. whether there's an existing service worker.
          if (navigator.serviceWorker.controller) {
            // The updatefound event implies that registration.installing is set:
            // https://slightlyoff.github.io/ServiceWorker/spec/service_worker/index.html#service-worker-container-updatefound-event
            var installingWorker = registration.installing;

            installingWorker.onstatechange = function () {
              switch (installingWorker.state) {
                case 'installed':
                  // At this point, the old content will have been purged and the
                  // fresh content will have been added to the cache.
                  // It's the perfect time to display a "New content is
                  // available; please refresh." message in the page's interface.
                  break;

                case 'redundant':
                  throw new Error('The installing ' +
                    'service worker became redundant.');

                default:
                  // Ignore
              }
            };
          }
        };
      }).catch(function (e) {
        console.error('Error during service worker registration:', e);
      });
  }

  // Your custom JavaScript goes here
  var signaturePad;
  var canvas;
  var focusing;
  var groupsArr = [];

  $(window).on('load', function () {
    'use strict';
    $('#preloader').delay(350).fadeOut('slow');
    $('body').delay(350).css({
      overflow: 'visible'
    });
  });

  $(document).ready(function () {
    var store = localforage.createInstance({
      name: "sar"
    });
    store.config({
      // driver: localforage.IndexedDB,
      name: 'LOTTO APP',
      storeName: 'lottoDb',
      description: 'lotto'
    });

    $('*').click(function() {
      $('#rand').attr('name', "new" + Number(new Date()));
    });

    function disableAutocomplete() {
      var nameSelector;
      nameSelector = "data-name";
      return document.querySelectorAll("form").forEach(function(form) {
        if (form.getAttribute("autocomplete") === "off") {
          form.querySelectorAll("input").forEach(function(input) {
            input.setAttribute(nameSelector, input.name);
            input.name = "new" + Number(new Date());
          });
          return form.addEventListener("submit", function() {
            return form.querySelectorAll("input").forEach(function(input) {
              input.name = input.getAttribute(nameSelector);
            });
          });
        }
      });
    }

    disableAutocomplete();

    store.ready().then(function () {

      function removeOrphans(target) {
        if ($(target).length > 0) {
          var $html = $(target).html();
          $html = $html.replace(/(\s)([\S])[\s]+/g, "$1$2&nbsp;");
          $(target).empty().html($html);
        }
      }
      removeOrphans($('#registerForm'));

      function resizeCanvas() {
        var ratio = Math.max(window.devicePixelRatio || 1, 1);
        canvas.width = canvas.offsetWidth * ratio;
        canvas.height = canvas.offsetHeight * ratio;
        canvas.getContext('2d').scale(ratio, ratio);
        signaturePad.clear();
      }

      if (document.querySelector('canvas')) {
        canvas = document.querySelector('canvas');
        signaturePad = new SignaturePad(canvas);

        resizeCanvas();
      }
      window.addEventListener('resize', resizeCanvas);

      function loadSettings() {
        store.getItem('uname', function (err, val) {
          $('#uname').val(val);
        });
        store.getItem('usurname', function (err, val) {
          $('#usurname').val(val);
        });
        store.getItem('uemail', function (err, val) {
          $('#uemail').val(val);
        });
        store.getItem('uemail', function (err, val) {
          $('#worker').val(val);
        });
        store.getItem('uid', function (err, val) {
          // $('#uid').val(val);
        });
        store.getItem('nazwa_eventu', function (err, val) {
          $('#nazwa_eventu').val(val);
        });
        store.getItem('wyswietlajKodPocztowy', function (err, val) {
          $('#wyswietlajKodPocztowy').prop('checked', val === true);
        });
        store.getItem('wymagajKodPocztowy', function (err, val) {
          $('#wymagajKodPocztowy').prop('checked', val === true);
        });
        store.getItem('wyswietlajMiejscowosc', function (err, val) {
          $('#wyswietlajMiejscowosc').prop('checked', val === true);
        });
        store.getItem('wymagajMiejscowosc', function (err, val) {
          $('#wymagajMiejscowosc').prop('checked', val === true);
        });
        store.getItem('wyswietlajUlica', function (err, val) {
          $('#wyswietlajUlica').prop('checked', val === true);
        });
        store.getItem('wymagajUlica', function (err, val) {
          $('#wymagajUlica').prop('checked', val === true);
        });
        store.getItem('wyswietlajNrDomu', function (err, val) {
          $('#wyswietlajNrDomu').prop('checked', val === true);
        });
        store.getItem('wymagajNrDomu', function (err, val) {
          $('#wymagajNrDomu').prop('checked', val === true);
        });
        store.getItem('wyswietlajNrLokalu', function (err, val) {
          $('#wyswietlajNrLokalu').prop('checked', val === true);
        });
        store.getItem('wymagajNrLokalu', function (err, val) {
          $('#wymagajNrLokalu').prop('checked', val === true);
        });
        if ($('#uemail').val()) {
          window.location.href = 'form.html';
        }
      }

      function handleInputs() {
        store.getItem('wyswietlajKodPocztowy', function (err, val) {
          if (val === true) {
            $('#kodpocztowy').closest('.hidden').removeClass('hidden');
          } else {
            $('#kodpocztowy').closest('.el-wrapper').addClass('hidden');
          }
        });
        store.getItem('wyswietlajMiejscowosc', function (err, val) {
          if (val === true) {
            $('#miejscowosc').closest('.hidden').removeClass('hidden');
          } else {
            $('#miejscowosc').closest('.el-wrapper').addClass('hidden');
          }
        });
        store.getItem('wyswietlajUlica', function (err, val) {
          if (val === true) {
            $('#ulica').closest('.hidden').removeClass('hidden');
          } else {
            $('#ulica').closest('.el-wrapper').addClass('hidden');
          }
        });
        store.getItem('wyswietlajNrDomu', function (err, val) {
          if (val === true) {
            $('#nrdomu').closest('.hidden').removeClass('hidden');
          } else {
            $('#nrdomu').closest('.el-wrapper').addClass('hidden');
          }
        });
        store.getItem('wyswietlajNrLokalu', function (err, val) {
          if (val === true) {
            $('#nrlokalu').closest('.hidden').removeClass('hidden');
          } else {
            $('#nrlokalu').closest('.el-wrapper').addClass('hidden');
          }
        });
        store.getItem('wymagajKodPocztowy', function (err, val) {
          if (val === true) {
            $('#kodpocztowy').prop('required', val);
          } else {
            $('#kodpocztowy').prop('required', val);
          }
        });
        store.getItem('wymagajMiejscowosc', function (err, val) {
          if (val === true) {
            $('#miejscowosc').prop('required', val);
          } else {
            $('#miejscowosc').prop('required', val);
          }
        });
        store.getItem('wymagajUlica', function (err, val) {
          if (val === true) {
            $('#ulica').prop('required', val);
          } else {
            $('#ulica').prop('required', val);
          }
        });
        store.getItem('wymagajNrDomu', function (err, val) {
          if (val === true) {
            $('#nrdomu').prop('required', val);
          } else {
            $('#nrdomu').prop('required', val);
          }
        });
        store.getItem('wymagajNrLokalu', function (err, val) {
          if (val === true) {
            $('#nrlokalu').prop('required', val);
          } else {
            $('#nrlokalu').prop('required', val);
          }
        });
      }

      function stringToSlug(str) {
        str = str.replace(/^\s+|\s+$/g, '');
        str = str.toLowerCase();

        var from = 'ąàáäâęèéëêìíïîòóöôùúüûñńçćłśóżź·/_,:;';
        var to = 'aaaaaeeeeeiiiioooouuuunncclsozz------';
        for (var i = 0, l = from.length; i < l; i++) {
          str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        str = str
          .replace(/[^a-z0-9 -]/g, '')
          .replace(/\s+/g, '-')
          .replace(/-+/g, '-');
        return str;
      }

      loadSettings();
      handleInputs();

      $('button[type="reset"]').click(function (e) {
        $('.submit-cta').text('Potwierdź');
        $('#registerForm')[0].reset();
        $('#podpis_zgoda_1, #podpis_zgoda_2, #podpis_zgoda_3').val('Nie');

        $('#podpis-wrp').collapse('hide');
        signaturePad.clear();
        $('html, body').animate({
          scrollTop: 0
        }, 'slow');
      });
      $('.lock-me').click(function (e) {
        e.preventDefault();
        store.setItem('lock', true);
        $('.locked-wrp').addClass('hidden');
        $('.unlocked-wrp').removeClass('hidden');
        $('#page-3').addClass('hidden');
        $('#page-2').removeClass('hidden');
      });

      $('.gotosettings').click(function () {
        store.getItem('lock', function (err, val) {
          if (err) {
            console.log(err);
          }
          if (val == false) {
            $('#page-2').addClass('hidden');
            $('#page-3').removeClass('hidden');
            $('.formSync').removeClass('hidden');
            $('.gotoform').closest('li').removeClass('hidden');
            $('.gotosettings').closest('li').addClass('hidden');
          }
        });
      });
      $('.gotoform').click(function () {
        $('#page-3').addClass('hidden');
        $('#page-2').removeClass('hidden');
        $('.formSync').addClass('hidden');
        $('.gotosettings').closest('li').removeClass('hidden');
        $('.gotoform').closest('li').addClass('hidden');
      });
      $('.cancel-cta, .navbar-brand').click(function () {
        $('#page-3').addClass('hidden');
        $('#page-2').removeClass('hidden');
        $('.formSync').addClass('hidden');
        $('.gotosettings').closest('li').removeClass('hidden');
        $('.gotoform').closest('li').addClass('hidden');
      });

      $('.toggle-lock').click(function (e) {
        e.preventDefault();
        $('.status').text('');
        $('#pin').modal('show');
        $('#pinVal').val('');
        $('#pinVal').trigger('focus');
      });
      $('#submitPin').click(function () {
        var sign = $('#pinVal').val();
        $('.status').text('');
        $.ajax({
          method: "POST",
          url: "https://sse.sare25.com/app_lock_lotto.php",
          data: {
            passwd: sign
          }
        }).done(function (msg) {
          if (msg == 'ok') {
            store.setItem('lock', false);
            $('#pin').modal('hide');
            $('.locked-wrp').removeClass('hidden');
            $('.unlocked-wrp').addClass('hidden');
          } else {
            $('.status').text('Błędny PIN');
          }
        });
      });
      store.getItem('lock', function (err, val) {
        if (val == false) {
          $('.locked-wrp').removeClass('hidden');
          $('.unlocked-wrp').addClass('hidden');
        } else {
          $('#page-3').addClass('hidden');
          $('#page-2').removeClass('hidden');
          $('.locked-wrp').addClass('hidden');
          $('.unlocked-wrp').removeClass('hidden');
        }
      });
      $('.toggle-signature').click(function (e) {
        e.preventDefault();
        if (window.innerWidth <= 768) {
          $('.navbar-toggle').trigger('click');
        }
        $('#code-status').text('');
        $('#page-3').addClass('hidden');
        $('#page-2').removeClass('hidden');
      });


      $('#kodpocztowy').on("keyup", function (event) {
        var selection = window.getSelection().toString();
        if (selection !== '') {
          return;
        }
        if ($.inArray(event.keyCode, [38, 40, 37, 39]) !== -1) {
          return;
        }
        var $this = $(this);
        var input = $this.val();
        input = input.replace(/[\W\s\._\-]+/g, '');
        var split = 2;
        var chunk = [];
        for (var i = 0, len = input.length; i < len; i += split) {
          split = (i >= 1 && i <= 5) ? 3 : 2;
          chunk.push(input.substr(i, split));
        }
        $this.val(function () {
          return chunk.join("-");
        });

      });

      $('.has-clear input').on('input propertychange', function () {
        var $this = $(this);
        var visible = Boolean($this.val());
        $this.siblings('.form-control-clear').toggleClass('hidden', !visible);
      }).trigger('propertychange');

      function send(ids, i) {
        store.getItem("form" + ids[i], function (err, val) {
          if (typeof val !== 'undefined' && val !== null) {
            var item = val;

            $.ajax({
              method: "POST",
              url: "https://sse.totalizator-sportowy.pl/app_lotto.php",
              data: JSON.parse(item)
            }).done(function (msg) {
              var result = JSON.parse(msg);

              if (result.status == 'ok') {
                var ids;
                store.getItem('formsId', function (err, val) {
                  ids = JSON.parse(val);
                  var formid = result.formid;
                  store.removeItem("form" + formid);

                  var z = ids.indexOf(parseInt(formid));
                  if (z != -1) {
                    ids.splice(z, 1);
                    store.setItem('formsId', JSON.stringify(ids));

                    if (ids.length === 0) {
                      // $('.synchro-container').fadeIn();
                      $('.preloader-synchro').hide();
                    }

                    $('.queue').html(ids.length);
                  }
                });

              }
            }).fail(function () {
              // $('.synchro-container').fadeIn();
              $('.preloader-synchro').hide();
            });
          } else {
            var ids;
            store.getItem('formsId', function (err, val) {
              ids = JSON.parse(val);
              var z = ids.indexOf(parseInt(ids[i]));
              if (z != -1) {
                ids.splice(z, 1);
                store.setItem('formsId', JSON.stringify(ids), function () {
                  if (ids.length === 0) {
                    // $('.synchro-container').fadeIn();
                    $('.preloader-synchro').hide();
                  }

                  $('.queue').html(ids.length);
                });

              }
            });
          }
        });
      }

      $('.sync-cta').click(function () {

        var ids;
        store.getItem('formsId', function (err, val) {
          ids = JSON.parse(val);

          if (ids && ids.length > 0) {

            // $('.synchro-container').hide();
            $('.preloader-synchro').fadeIn();

            for (var i = 0; i < ids.length; i++) {
              send(ids, i);
            }
          }
        });
      });

      $('.form-control-clear').click(function () {
        $(this).siblings('input').val('')
          .trigger('propertychange').focus();
      });

      function hashifyUserEmail(value) {
        var outputVal = value;
        if (value.indexOf('@') > 0) {
          var valToRelapce = value.substring(value.indexOf('@') + 1, value.lastIndexOf('.'));
          var starsCount = valToRelapce.length;
          var statsString = '';
          for (var i = 0; i < valToRelapce.length; i++) {
            statsString += '*';
          }
          outputVal = value.replace(valToRelapce, statsString);
        }
        return outputVal;
      }

      jQuery.validator.addMethod('noSpace', function (value) {
        return value === '' || value.trim().length !== 0;
      }, 'Wpisz poprawną wartość');

      $.validator.addMethod('strictEmail', function (value, element) {
        return /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/.test(value);
      }, 'Proszę podać poprawny e-mail');

      function prefixifyGsm(value) {
        return /^[+]+48[0-9]{9,9}$/.test(value) ? value : '+48' + value;
      }

      $.validator.addMethod('kodPocztowy', function (value, element) {
        return /^\d+(-\d+)*$/.test(value);
      }, 'Proszę podać poprawny kod pocztowy');

      $.validator.addMethod('kodPocztowy', function (value, element) {
        if (value.trim().length > 0) {
          if (window.sarelang == 'cz' || window.sarelang == 'sk') {
            return /\d{3}-\d{2}/.test(value) && value.length == 6;
          } else {
            return /\d{2}-\d{3}/.test(value) && value.length == 6;
          }
        } else {
          return true;
        }
      }, 'Wprowadź popranwy kod pocztowy');

      $('[data-toggle="tooltip"]').tooltip();

      $('#dataUr').datetimepicker({
        locale: 'pl',
        format: 'DD.MM.YYYY'
      });

      $('.fold-up').on('click', function () {
        $('#podpis-wrp').collapse('hide');
        signaturePad.clear();
        $('.submit-cta').text('Potwierdź');
      });

      $('.clear-pad').on('click', function () {
        signaturePad.clear();
      });
      if ($('#aleosiemnastka') && $('#aleosiemnastka').prop('checked')) {
        $('.aleosiemnastka').addClass('el-checked');
        $('#registerForm').removeClass('hidden');
      } else {
        $('.aleosiemnastka').removeClass('el-checked');
        $('#registerForm').addClass('hidden');
      }
      $('#aleosiemnastka').on('change', function (e) {
        if (e.target.checked) {
          $('.aleosiemnastka').addClass('el-checked');
          $('#registerForm').removeClass('hidden');
        } else {
          $('.aleosiemnastka').removeClass('el-checked');
          $('#registerForm').addClass('hidden');
        }
      });

      // wyloguj - skasuj email z LS i przejdź na stronę logowania
      $('.log-out').on('click', function (e) {
        var _this = this;
        store.setItem('uemail', '');
        store.setItem('lock', true, function () {
          e.preventDefault();
          window.location = $(_this).attr('href');
        });
      });

      // wyświetl e-mail zalogowanej osoby
      store.getItem('uemail', function (err, val) {
        if (val && $('.user-email').length) {
          $('.user-email').html(hashifyUserEmail(val));
        }
      });
      var formsId = [];
      store.getItem('formsId', function (err, val) {
        if (err) {
          console.log('err: ', err);
        } else if (val === null) {
          formsId = [];
        } else {
          formsId = JSON.parse(val);
          $('.queue').html(formsId.length);
        }
      });

      // checkboxes handlarz - zmienia wartości na TAK, NIE i brak danych

      $('#podpis_zgoda_1, #podpis_zgoda_2, #podpis_zgoda_3').change(function () {
        if (this.checked) {
          $(this).val('Tak');
        } else {
          $(this).val('Nie');
        }
      });

      $('.save-cta').click(function () {
        new Promise(function (resolve) {
            store.getItem('nazwa_eventu', function (err, val) {
              store.setItem('nazwa_eventu', stringToSlug($('#nazwa_eventu').val()));
              $('#nazwa_eventu').val(val);
            });
            store.setItem('wyswietlajKodPocztowy', $('#wyswietlajKodPocztowy').prop('checked'));
            store.setItem('wymagajKodPocztowy', $('#wymagajKodPocztowy').prop('checked'));
            store.setItem('wyswietlajMiejscowosc', $('#wyswietlajMiejscowosc').prop('checked'));
            store.setItem('wymagajMiejscowosc', $('#wymagajMiejscowosc').prop('checked'));
            store.setItem('wyswietlajUlica', $('#wyswietlajUlica').prop('checked'));
            store.setItem('wymagajUlica', $('#wymagajUlica').prop('checked'));
            store.setItem('wyswietlajNrDomu', $('#wyswietlajNrDomu').prop('checked'));
            store.setItem('wymagajNrDomu', $('#wymagajNrDomu').prop('checked'));
            store.setItem('wyswietlajNrLokalu', $('#wyswietlajNrLokalu').prop('checked'));
            store.setItem('wymagajNrLokalu', $('#wymagajNrLokalu').prop('checked'), function () {
              resolve();
            });
          }).then(function () {
            handleInputs();
            $('#page-3').addClass('hidden');
            $('#page-2').removeClass('hidden');
            // $('.formSync').addClass('hidden');
            $('.gotosettings').closest('li').removeClass('hidden');
            $('.gotoform').closest('li').addClass('hidden');
          })
          .catch(function (err) {
            console.log('err: ', err);
          });
      });

      // walidacja logowania
      $('#loginForm').submit(function (e) {
        e.preventDefault();
      }).validate({
        ignore: '.ignore',
        submitHandler: function () {

          var validator = this;
          var formData = $('#loginForm').serialize();

          $.ajax({
            method: "POST",
            url: "https://utl.sare25.com/jb/login_d.php",
            data: formData
          }).done(function (msg) {

            var result = JSON.parse(msg);

            if (result.status == 'ok') {
              store.setItem('uname', result.data.firstname);
              store.setItem('usurname', result.data.lastname);
              store.setItem('uemail', result.data.email);
              store.setItem('uid', result.data.uid, function () {
                window.location.href = 'form.html';
                return false;
              });
            } else {
              validator.showErrors(result.errors);
            }
          });
        },
        errorPlacement: function (error, element) {
          error.appendTo(element.closest('.el-wrapper'));
        },
        highlight: function (element) {
          $(element).parent().addClass('animated shake invalid');
          $(element).addClass('invalid');
        },
        unhighlight: function (element) {
          $(element).parent().removeClass('animated shake invalid');
          $(element).removeClass('invalid');
        },
        focusInvalid: true,
        onfocusout: false,
        focusCleanup: false,
        rules: {
          Przedstawiciel_Login: 'required',
          Przedstawiciel_Haslo: 'required'
        },
        messages: {
          Przedstawiciel_Login: 'Proszę wypełnić pole login',
          Przedstawiciel_Haslo: 'Proszę wypełnić hasło'
        }
      });
      // helper variable
      var x = null;

      // walidacja rejestracji
      $('#registerForm').submit(function (e) {
        x = $(e.target).serializeObject();
        e.preventDefault();
      }).validate({
        ignore: '.hidden',
        submitHandler: function (fm) {
          // Sprawdź podpis
          if (signaturePad.isEmpty()) {
            if (!$('#podpis-wrp').hasClass('in')) {
              $('#podpis-wrp').collapse('show');
              $('html, body').animate({
                scrollTop: $(document).height()
              }, 'slow');
            }
            $('.sign-status').text('Zostaw podpis');
            var fontSize = parseInt($('.sign-status').css('font-size'));
            if (fontSize <= '15') {
              fontSize = fontSize + 1 + 'px';
              $('.sign-status').css({
                'font-size': fontSize
              });
            }
            setTimeout(function () {
              resizeCanvas();
            }, 1000);
            $('.submit-cta').text('Zapisz');

          } else {
            // podpisano
            var newFormId = Date.now();
            var formsId;
            store.getItem('formsId', function (err, val) {
              if (val === null) {
                formsId = [newFormId];
              } else {
                formsId = JSON.parse(val);
                formsId.push(newFormId);
              }
              formsId = JSON.stringify(formsId);
              var data = $('#registerForm').serializeObject();
              data.sign = signaturePad.toDataURL();
              data.formid = newFormId;
              data.Mail_przedstawiciela = $('#uemail').val();
              data.gsm = prefixifyGsm(data.gsm);
              var d = new Date();
              data.date = d.getTime();
              data.Data_podpisu = d.getTime();
              data.Event = $('#nazwa_eventu').val();

              var formData = data;

              store.setItem('formsId', formsId);
              store.setItem('form' + newFormId, JSON.stringify(formData), function () {
                // wyświetl kolejkę
                if (formsId) {
                  formsId = JSON.parse(formsId);
                  $('.queue').html(formsId.length);
                }

                $('#thank-you').modal('show');

                $.ajax({
                  method: "POST",
                  url: "https://sse.totalizator-sportowy.pl/app_lotto.php",
                  data: formData
                }).done(function (msg) {
                  var result = JSON.parse(msg);
                  if (result.status == 'ok') {
                    store.removeItem('form' + newFormId);

                    var i = formsId.indexOf(newFormId);
                    if (i != -1) {
                      formsId.splice(i, 1);
                      store.setItem('formsId', JSON.stringify(formsId));
                    }

                    $('.queue').html(formsId.length);

                    if (store.getItem('formsId') === "") {
                      store.removeItem('formsId');
                    }
                  }

                });
                // resetuj form
                $('.submit-cta').text('Potwierdź');
                $('#registerForm')[0].reset();
                $('#podpis_zgoda_1, #podpis_zgoda_2, #podpis_zgoda_3').val('Nie');

                $('#podpis-wrp').collapse('hide');
                signaturePad.clear();
                $('html, body').animate({
                  scrollTop: 0
                }, 'slow');

              });
            });


          }

          return false;
        },
        errorPlacement: function (error, element) {
          error.appendTo(element.closest('.el-wrapper'));
        },
        highlight: function (element) {
          $(element).closest('.el-wrapper').addClass('animated shake invalid');
          $(element).addClass('invalid');
        },
        unhighlight: function (element) {
          $(element).closest('.el-wrapper').removeClass('animated shake invalid');
          $(element).removeClass('invalid');
        },
        focusInvalid: true,
        onfocusout: false,
        focusCleanup: false,
        rules: {
          prop1: {
            required: true,
            noSpace: true,
            minlength: function () {
              return $('#limie').val() === '' ? false : 3;
            }
          },
          prop2: {
            required: true,
            noSpace: true,
            minlength: function () {
              return $('#lnazwisko').val() === '' ? false : 3;
            }
          },
          email: {
            required: true,
            email: true,
            noSpace: true,
            strictEmail: true
          },
          gsm: {
            minlength: 9,
            maxlength: 9,
            number: function () {
              return $('#podpis_zgoda_2').prop('checked') || $('#podpis_zgoda_3').prop('checked');
            },
            required: function () {
              return $('#podpis_zgoda_2').prop('checked') || $('#podpis_zgoda_3').prop('checked');
            }
          },
          aleosiemnastka: 'required',
          Zgoda_1: 'required',
          Zgoda_2: {
            required: function () {
              return $('#tel').val().trim() !== '';
            }
          },
          Zgoda_3: {
            required: function () {
              return $('#tel').val().trim() !== '';
            }
          },
          prop3: {
            noSpace: function () {
              return $('#kodpocztowy').prop('required') === true && $('#kodpocztowy').closest('.el-wrapper').hasClass('hidden') === false;
            },
            required: function () {
              return $('#kodpocztowy').prop('required') === true && $('#kodpocztowy').closest('.el-wrapper').hasClass('hidden') === false;
            },
            kodPocztowy: function () {
              return $('#kodpocztowy').val() !== '';
            }
          },
          prop5: {
            required: function () {
              return $('#miejscowosc').prop('required') === true && $('#miejscowosc').closest('.el-wrapper').hasClass('hidden') === false;
            },
            minlength: function () {
              return $('#miejscowosc').val() === '' ? false : 3;
            }
          },
          prop6: {
            required: function () {
              return $('#ulica').prop('required') === true && $('#ulica').closest('.el-wrapper').hasClass('hidden') === false;
            },
            minlength: function () {
              return $('#ulica').val() === '' ? false : 3;
            }
          },
          prop7: {
            noSpace: function () {
              return $('#nrdomu').prop('required') === true && $('#nrdomu').closest('.el-wrapper').hasClass('hidden') === false;
            },
            required: function () {
              return $('#nrdomu').prop('required') === true && $('#nrdomu').closest('.el-wrapper').hasClass('hidden') === false;
            }
          },
          prop8: {
            required: function () {
              return $('#nrlokalu').prop('required') === true && $('#nrlokalu').closest('.el-wrapper').hasClass('hidden') === false;
            }
          }
        },
        messages: {
          prop1: {
            required: 'Proszę podać imię',
            minlength: 'Proszę podać minimum 3 znaki'
          },
          prop2: {
            required: 'Proszę podać nazwisko',
            minlength: 'Proszę podać minimum 3 znaki'
          },
          prop3: {
            required: 'Proszę wypełnić to pole'
          },
          prop5: {
            required: 'Proszę wypełnić to pole',
            minlength: 'Proszę podać minimum 3 znaki'
          },
          prop6: {
            required: 'Proszę wypełnić to pole',
            minlength: 'Proszę podać minimum 3 znaki'
          },
          prop7: {
            required: 'Proszę wypełnić to pole'
          },
          prop8: {
            required: 'Proszę wypełnić to pole'
          },
          email: {
            required: 'Proszę wypełnić pole e-mail',
            email: 'Podaj właściwy adres e-mail'
          },
          gsm: {
            required: 'Proszę wypełnić to pole',
            minlength: 'Niepoprawny format numeru telefonu',
            maxlength: 'Niepoprawny format numeru telefonu',
            number: 'Niepoprawny format numeru telefonu'
          },
          aleosiemnastka: 'Wymagany wiek 18 wzwyż',
          Zgoda_1: 'Proszę zaznaczyć zgodę',
          Zgoda_2: 'Proszę zaznaczyć zgodę',
          Zgoda_3: 'Proszę zaznaczyć zgodę'
        }
      });


      // fix dla iOS dla elementów które moja pozycję fixed
      $('input, select, textarea').on('focus', function () {
        $('.navbar').css({
          position: 'absolute',
          top: $(document).scrollTop()
        });
        focusing = true;
      });
      $('input, select, textarea').on('blur', function () {
        $('.navbar').css({
          position: 'fixed',
          top: 0
        });
        focusing = false;
      });

    });
  });

  $(window).scroll(function () {
    if (focusing) {
      $('.navbar').css({
        top: $(document).scrollTop()
      });
    }
  });
})();
